module.exports = __webpack_public_path__ + "static/media/icon-important.6a1fa8bc.svg";